import {useContext, useState} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {useDispatch} from "react-redux";
import {FormattedMessage} from "react-intl";

import CheckForm from "./CheckForm";
import VerifyForm from "./VerifyForm";

import {ContextLayout} from "@layouts/web";
import {urls} from "@api/urls";
import {PostRequest} from "@configs/request";
import Ping from '@configs/request/Ping';
import {handleLogin} from "@store/actions/auth";
import LoginStatus from "@utils/types/LoginStatus";
import handleFieldsData from "@utils/handleFieldsData";
import Notify from "@components/noty/notify";
import "./style.scss";

const Login = () => {
        const dispatch = useDispatch();

        const [step, setStep] = useState(1);
        const [registerStatus, setRegisterStatus] = useState(0);
        const [registerInfo, setRegisterInfo] = useState(
            {
                firstName: "",
                lastName: ""
            }
        );
        const [verifyToken, setVerifyToken] = useState();
        const [loginValue, setLoginValue] = useState();
        const [otp, setOtp] = useState('');
        const [isLoading, setIsLoading] = useState(false);

        const Context = useContext(ContextLayout);

        const checkLoginValue = () => {
            setIsLoading(true);
            const data = {
                'login': loginValue
            }
            PostRequest(urls.web.login.check, data).then((response) => {
                    if (response) {
                        const {ok, data} = response;

                        if (ok && data) {
                            setVerifyToken(data.verify_token);
                            setRegisterStatus(data.status);
                            handleStep(2);
                            if (data.status === 1)
                                Notify('success', 'top-left', `کد تایید به ${loginValue} ${data.otp_type} شد. `);
                        }
                    }
                }
            ).finally(() => {
                setIsLoading(false);
            })
        }

        const handleRegisterInfoChange = (event, fieldData) => {
            let tempFormValues = {...registerInfo};
            if (fieldData.name === "province" && registerInfo.city?.value) {
                tempFormValues = {...tempFormValues, city: null};
            }
            handleFieldsData(tempFormValues, setRegisterInfo, event, fieldData);
            /*let temp = registerInfo;
            temp[event.target.name] = event.target.value;
            setRegisterInfo({...temp})*/
        }

        const handleStep = (step) => {
            setStep(step);
        }

        const verify = () => {
            setIsLoading(true);

            const data = {
                'first_name': registerInfo.firstName,
                'last_name': registerInfo.lastName,
                'otp': otp,
                'verify_token': verifyToken,
                // 'national_code': registerInfo.national_code,
                // 'city_id': registerInfo.city?.value,
                // 'address': registerInfo.address
            }
            PostRequest(urls.web.login.verify, data)
                .then((response) => {
                    if (response) {
                        const {ok, data} = response;

                        if (ok && data) {
                            dispatch(handleLogin(data.token));
                            toggleModal();
                            resetForm();
                            Ping();
                            Notify('success', 'top-left', "با موفقیت وارد شدید.");
                        }
                    }
                })
                .catch(() => {
                    setOtp("");
                })
                .finally(() => {
                    setIsLoading(false);
                })
        }

        const resetForm = () => {
            setLoginValue("");
            setRegisterInfo({
                firstName: "",
                lastName: ""
            });
            setVerifyToken("");
            setOtp("");
            setStep(1);
        }

        const toggleModal = () => {
            Context?.showLoginModal();
        }

        return (
            <Modal
                isOpen={Context?.isLoginModalOpen}
                toggle={toggleModal}
                className="modal-dialog-centered login-modal"
                size="sm"
            >
                <ModalHeader toggle={toggleModal}>
                    {(step === 2 && parseInt(registerStatus) === LoginStatus.NotRegistered) ?
                        <FormattedMessage id="register"/>
                        :
                        <FormattedMessage id="loginToAccount"/>
                    }
                </ModalHeader>

                <ModalBody>
                    {step === 1 &&
                        <CheckForm
                            loginValue={loginValue}
                            setLoginValue={setLoginValue}
                            handleCheckLogin={checkLoginValue}
                            isLoading={isLoading}
                        />
                    }

                    {step === 2 &&
                        <VerifyForm
                            loginValue={loginValue}

                            otp={otp}
                            setOtp={setOtp}

                            setVerifyToken={setVerifyToken}

                            registerInfo={registerInfo}
                            handleRegisterInfoChange={handleRegisterInfoChange}

                            isLoading={isLoading}
                            registerStatus={registerStatus}
                            handleStep={handleStep}
                            handleVerify={verify}
                        />
                    }
                </ModalBody>
            </Modal>
        );
    }
;

export default Login;
